import React from 'react';
import { Button } from '../../../../button/button';
import styles from './button-cell.module.scss';
export const ButtonCell = ({ data, colDef, }) => {
    const { ...restProps } = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) ? data[colDef.colId] : {};
    return (React.createElement("div", { className: styles.buttonCellContainer },
        React.createElement(Button, { ...restProps, className: styles.button })));
};
//# sourceMappingURL=button-cell.js.map